/**
 * Created by seven on 2018/4/27.
 */

export default {
  auth: {
    btns: {
      login: '登入',
      forgetPw: '忘記密碼？',
      submit: '送出',
      backToLogin: '前往登入',
      sendMailAgain: '重新發送新信件',
      confirm: '確認',
      googleLogout: '登出google帳號並回到上一頁'
    },
    login: '登入',
    logout: '登出',
    brand: '品牌名稱',
    admin:'Google登入',
    email: '電子郵件',
    password: '密碼',
    forgetPw: '忘記密碼',
    logoSubtitle: '輕鬆掌握多元金流支付交易',
    firstLogin: '第一次使用前請先完成設定',
    finishFirstLogin: '您已完成設定，請重新登入',
    firstLoginSteps: {
      changePw: '變更密碼',
      uploadImg: '上傳商店圖片',
      changePwSuccess: '密碼變更設定。',
      uploadImgSuccess: '商店圖片設定。',
      uploadImgFail: '商店圖片設定尚未完成，稍後可在後台帳號資訊裡做變更。'
    },
    forgetPwDesc: {
      step1: '請輸入電子郵件帳號',
      step2: '前往信箱收取認證信',
      step3: '重設密碼',
      sendMailDesc: '我們已將認證信件寄至您的信箱，請您前往收取，該連結將於 1 小時後或重設密碼後失效，謝謝。',
      sendMailTip: '提示：如果您沒有收到「密碼重設」電子郵件，建議您到垃圾郵件查詢。'
    },
    resetPw: {
      password: '請輸入原密碼',
      newPassword: '8 至 16 碼，英文和數字',
      confirmPassword: '再次確認新密碼',
      confirmPwLabel: '新密碼',
      successReset: '密碼變更完成，請以新密碼登入。',
      successResetTip: '提示：5 秒後自動前往登入頁。',
      resetExpired: '您已設定過新密碼或重置密碼信已超過 1 小時，請重新發送新信件！'
    }
  },
  portal: {
    btns: {
      changePw: '變更密碼'
    },
    units: {
      price: '元',
      times: '次',
      count: '筆'
    },
    charts: {
      title: {
        price: '交易總額',
        times: '交易數',
        count: ''
      }
    },
    tables: {
      salesEmpty: '目前沒有交易資料。',
      salesEmpty1: '取消的交易不列入計算。',
      notifiEmpty: '目前沒有訊息通知。',
      empty: '目前沒有任何資料。'
    },
    payments: {
      credit: '信用卡',
      linepay: 'LINE Pay',
      periodicpay:'信用卡 定期定額',
      applepay: 'Apple Pay',
      googlepay: 'Google Pay',
      samsungpay: 'Samsung Pay',
      piapp: 'Pi 行動錢包',
      ipass: '一卡通',
      easycard: '悠遊卡',
      installment: '信用卡 - 分期付款',
      point: '信用卡 - 紅利折抵',
      jkos: '街口支付',
      taiwanpay: '台灣 Pay',
      wechatpay: '微信支付',
      alipay: '支付寶',
      inst_: '信用卡 {msg} 期',
      units: {
        month: '月',
        day: '日',
        dailyTimes: '每卡每日'
      },
      category: {
        credit: '信用卡',
        electronic: '電子票證',
        mobile: 'QR Payment'
      },
      type: {
        online: '網路',
        offline: '實體',
        omni: '全渠道'
      },
      feeRate: '交易手續費率',
      tDay: '撥款／退款天數',
      methods: {
        credit: '一次付清',
        point: '紅利折抵',
        installment: '分期付款',
        jcb: 'JCB',
        visa: 'VISA',
        master_card: 'MasterCard',
        union_pay: '銀聯卡',
        diners_club: '大來卡',
        ae: '美國運通卡',
        inst_: '{msg} 期'
      }
    },
    reports: {
      columns: {
        storeId: '店名',
        status: '狀態',
        orderNo: '支付流水編號',
        txnTime: '交易時間',
        txnSource: '交易來源',
        paymentMethod: '付款方式',
        cardNo: '末四碼',
        paymentAmount: '交易金額',
        captureStatus: '請款狀態',
        estFundsTransferTime: '預估撥款日',
        duringTime: '交易時間',
        number: '交易數',
        revenueAmount: '交易金額',
        settlementTime: '清算日期',
        txnChannel: '交易來源',
        feeRate: '手續費率',
        processingFee: '預估手續費',
        fundsTransfer: '預估撥款金額',
        periodicpayPeriod:'交易期數',
        totalPeriodicpayPeriod:'總期數'
      },
      captureStatus: {
        positive0: '待請款',
        positive1: '請款中',
        positive2: '請款成功',
        positive9: '請款失敗，請聯絡客服',
        positive9_1: '請款失敗',
        negative0: '待退款',
        negative1: '退款中',
        negative2: '退款成功',
        negative9: '退款失敗，請聯絡客服',
        negative9_1: '退款失敗',
        normal0: '待請款 / 待退款',
        normal1: '請款中 / 退款中',
        normal2: '請款成功 / 退款成功',
        normal9: '請款失敗 / 退款失敗'
      }
    },
    notifications: {
      announcement: '公告通知',
      maintenance: '維護通知',
      member: '會員通知'
    },
    strings: {
      totalPrice: '營業額',
      totalNumber: '交易數'
    }
  },
  errors: {
    over1hr: '閒置超過 1 小時或驗證失效',
    authFail: '品牌名稱、使用者帳號或密碼錯誤。',
    authKickOut: '您已被登出，請重新登入。',
    authContractFail: '帳號尚未準備完成。',
    serverFail: '發生了些問題',
    serverRetry: '請刷新頁面後重新嘗試',
    serverTimeout: '操作逾時',
    withoutEthernet: '無網路連接',
    unknowFail: '未知的錯誤',
    forgetPwFail: '品牌名稱、電子郵件或密碼錯誤。',
    resetPwRepeat: '您已設定過新密碼，如需修改請重新申請。',
    originPwError: '原密碼錯誤。',
    pageNotFoundError: '發生了些錯誤',
    pageNotFoundDesc: '我們找不到 {msg} 這個頁面',
    quotaLimitOverError: '收款額度不足',
    quotaLimitOverSubtitle: '信用卡收款額度已達 100%',
    quotaLimitError: '收款額度即將額滿',
    quotaLimitErrorSubtitle: '信用卡收款額度已達 {msg} %',
    quotaLimitDesc: '若需提高收款額度，請電洽 24 小時服務專線 <a href="tel:02-2267-5557">02-2267-5557</a>',
    uploadImgOverSize: '格式不符',
    uploadImgOverSizeDesc: '接受JPG、PNG 格式，檔案大小 1 MB 以內\n' + '建議尺寸為 85*85 px，長寬比例 1:1'
  }
}
